webpackJsonp([1],{

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
// Default State

var isLocal = window.location.href.indexOf('localhost') >= 0;
var ABSOLUTE_URL = isLocal ? 'http://dev-acerstat.devup.cc' : '';
// const ABSOLUTE_URL = '';
var URL_ROOT = '/api';

var state = {
    baseUrl: ABSOLUTE_URL,
    apiUrl: ABSOLUTE_URL + URL_ROOT
};

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_typograf__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_typograf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_typograf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validate__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tools_Helpers__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_swiper_dist_css_swiper_css__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tools_share__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_scss_app_scss__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_scss_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_scss_app_scss__);










// require styles


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper___default.a);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* default */], {
    locale: 'ru',
    dictionary: {
        en: __WEBPACK_IMPORTED_MODULE_6__validate__["a" /* dictionary */].en,
        ru: __WEBPACK_IMPORTED_MODULE_6__validate__["a" /* dictionary */].ru
    }
});
var Tp = new __WEBPACK_IMPORTED_MODULE_4_typograf___default.a({ locale: ['ru', 'en-US'] });
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('typograph', {
    bind: function bind(el, binding, vnode) {
        el.innerHTML = Tp.execute(el.innerHTML);
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10__tools_share__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */],
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    data: function data() {
        return {
            Helpers: __WEBPACK_IMPORTED_MODULE_7__tools_Helpers__["a" /* default */],
            isMobile: __WEBPACK_IMPORTED_MODULE_7__tools_Helpers__["a" /* default */].isMobile(),
            gaSend: __WEBPACK_IMPORTED_MODULE_7__tools_Helpers__["a" /* default */].ga().send
        };
    },
    created: function created() {
        window.vue = this;
    },

    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Resize__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Resize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Menu__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_icons__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(70);



//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            supportsWEBP: 'png',
            menuClass: null
        };
    },

    components: {
        'menu-app': __WEBPACK_IMPORTED_MODULE_4__components_common_Menu___default.a,
        Resize: __WEBPACK_IMPORTED_MODULE_3__components_common_Resize___default.a,
        'to-top': __WEBPACK_IMPORTED_MODULE_5__assets_svg_icons__["a" /* default */].arrowNext
    },
    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])(['getCurrentBg'])),
    methods: {
        toTop: function toTop() {
            this.$refs.page.$el.scrollTo(0, 0);
        },
        changeMenuClass: function changeMenuClass(data) {
            this.menuClass = data ? 'fix' : '';
        }
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.$root.Helpers.supportsWEBP();

                        case 2:
                            if (!_context.sent) {
                                _context.next = 6;
                                break;
                            }

                            _context.t0 = 'webp';
                            _context.next = 7;
                            break;

                        case 6:
                            _context.t0 = 'png';

                        case 7:
                            _this.supportsWEBP = _context.t0;

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    watch: {
        '$route': {
            immediate: true,
            handler: function handler(to, from) {
                if (to.name == 'Index') !this.$root.isMobile ? this.$store.commit('updateCurrentBg', '/static/img/pages/main/main_bg.jpg') : this.$store.commit('updateCurrentBg', '/static/img/pages/main/main_bg_mobile.jpg');
            }
        }
    }
});

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_logo_svg__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_svg_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_icons__ = __webpack_require__(55);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Menu',
    props: ['menuClass'],
    data: function data() {
        return {
            stateMenu: false,
            shareLinks: [{
                img: '/static/svg/icons/ico__fb.svg',
                network: 'fb'
            }, {
                img: '/static/svg/icons/ico__ok.svg',
                network: 'ok'
            }, {
                img: '/static/svg/icons/ico__tele.svg',
                network: 'tg'
            }, {
                img: '/static/svg/icons/ico__tw.svg',
                network: 'tw'
            }, {
                img: '/static/svg/icons/ico__vk.svg',
                network: 'vk'
            }]
        };
    },

    components: {
        "logo-app": __WEBPACK_IMPORTED_MODULE_0__assets_svg_logo_svg___default.a,
        "heart-app": __WEBPACK_IMPORTED_MODULE_1__assets_svg_icons__["a" /* default */].heart,
        "menu-app": __WEBPACK_IMPORTED_MODULE_1__assets_svg_icons__["a" /* default */].menu,
        "menu-close": __WEBPACK_IMPORTED_MODULE_1__assets_svg_icons__["a" /* default */].close
    },
    methods: {
        toMain: function toMain() {
            this.$router.push('/');
        },
        shareUrl: function shareUrl() {
            return window.location.href;
        }
    },
    watch: {
        'stateMenu': function stateMenu(to, from) {
            this.$store.commit('updateMenuState', to);
        }
    },
    mounted: function mounted() {
        if (this.$root.isMobile) {}
    }
});

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


var defaultWidth = 1400,
    defaultFont = 16,
    minWidth = 768,
    minHeight = 600,
    defaultHeight = 790;

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Resize',
    mounted: function mounted() {
        window.addEventListener('resize', this.onResize.bind(this));
    },
    data: function data() {
        return {
            vW: window.innerWidth,
            vH: window.innerHeight
        };
    },

    computed: {
        fSize: function fSize() {
            return !this.$root.isMobile ? 16 * Math.min(Math.max(minWidth, this.vW) / defaultWidth, Math.max(minHeight, this.vH) / defaultHeight) : 16;
        }
    },
    methods: {
        onResize: function onResize() {
            this.vW = window.innerWidth;
            this.vH = window.innerHeight;
        }
    }

});

/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_icons__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_ru__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_ru___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_locale_ru__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(70);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Preview",
    props: ['matches'],
    components: {
        'calendar': __WEBPACK_IMPORTED_MODULE_1__assets_svg_icons__["a" /* default */]['calendar'],
        'watch': __WEBPACK_IMPORTED_MODULE_1__assets_svg_icons__["a" /* default */]['watch'],
        'arrow-next': __WEBPACK_IMPORTED_MODULE_1__assets_svg_icons__["a" /* default */].arrowNext,
        'arrow-prev': __WEBPACK_IMPORTED_MODULE_1__assets_svg_icons__["a" /* default */].arrowPrev
    },
    data: function data() {
        var self = this;
        return {
            self: this,
            topSliderOptions: {
                navigation: {
                    nextEl: '.top-next-slide',
                    prevEl: '.top-prev-slide'
                },
                on: {
                    init: function init() {
                        self.getActiveIndex(this);
                    }
                }
            },
            navigationSliderOptions: {
                slidesPerView: 4,
                slidesPerColumn: 2,
                slidesPerGroup: 4,
                slideToClickedSlide: true,
                navigation: {
                    nextEl: '.navigation-next-slide',
                    prevEl: '.navigation-prev-slide'
                },
                breakpoints: {
                    1023: {
                        slidesPerColumn: 1,
                        slidesPerGroup: 1,
                        direction: 'vertical',
                        slidesPerView: 'auto',
                        loop: true
                    }
                }
            },
            time: null,
            date: null,
            currentMatch: null,
            currentIndex: 0
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
        menuState: 'getMenuState'
    })),
    methods: {
        getData: function getData(value) {
            this.date = __WEBPACK_IMPORTED_MODULE_2_moment__(value).format("DD MMM");
        },
        getTime: function getTime(value) {
            this.time = __WEBPACK_IMPORTED_MODULE_2_moment__(value).format("H:mm");
        },
        getActiveIndex: function getActiveIndex(swiper) {
            this.currentIndex = !swiper ? this.$refs['top-slider'].swiper.activeIndex : swiper.activeIndex;
            this.currentMatch = this.matches.items[this.currentIndex];
            this.$emit("changedStatistic", this.currentMatch);
        }
    },
    watch: {
        'currentMatch': function currentMatch(to, from) {
            var date = to.date_time,
                time = to.date_time;
            this.getData(date);
            this.getTime(time);
        },
        'currentIndex': function currentIndex(to, from) {
            this.$refs['top-slider'].swiper.slideTo(to);
        }
    }
});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_preview__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_bigView__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_bigView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_parts_bigView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_parts_smallView__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_parts_smallView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_parts_smallView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configs_banners__ = __webpack_require__(339);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Index',
    props: ['supportsWEBP', 'bg'],
    data: function data() {
        return {
            statistic: null,
            currentMatch: null,
            currentScrollPosition: null,
            banners: __WEBPACK_IMPORTED_MODULE_5__configs_banners__["a" /* default */]
        };
    },

    components: {
        'preview-app': __WEBPACK_IMPORTED_MODULE_2__components_common_preview___default.a,
        bigView: __WEBPACK_IMPORTED_MODULE_3__components_parts_bigView___default.a,
        smallView: __WEBPACK_IMPORTED_MODULE_4__components_parts_smallView___default.a
    },
    methods: {
        gaEvent: function gaEvent(category, action, label) {
            this.$root.gaSend(category, action, label);
        },
        getData: function getData() {
            this.$store.dispatch('getMatches');
        },
        getStatistic: function getStatistic(data) {
            this.currentMatch = data;
            this.statistic = data.statistic;
        },
        changeMenuClass: function changeMenuClass() {
            var dHeight = this.$refs['content'].clientHeight,
                top = this.$el.scrollTop;

            if (top >= dHeight / 3 && top < dHeight / 3 * 2) {
                this.currentScrollPosition = '30%';
            } else if (top >= dHeight / 3 * 2 && top < dHeight - this.$el.clientHeight) {
                this.currentScrollPosition = '60%';
            } else if (top == dHeight - this.$el.clientHeight) {
                this.currentScrollPosition = '100%';
            } else {
                this.currentScrollPosition = null;
            }

            var menuClass = top > 0 ? true : false;
            this.$emit('changeMenuClass', menuClass);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        matches: 'getMatches',
        menuState: 'getMenuState'
    })),
    created: function created() {
        this.getData();
    },

    watch: {
        currentMatch: function currentMatch(to, from) {
            if (to) this.$root.gaSend('main', 'show', to.fkParticipants1.name + '-' + to.fkParticipants2.name);
        },
        currentScrollPosition: function currentScrollPosition(to, from) {
            if (to) this.$root.gaSend('main', 'scroll', to);
        }
    }
});

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__productSlider__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__productSlider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__productSlider__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductBase',
    props: ['bg'],
    components: {
        productSlider: __WEBPACK_IMPORTED_MODULE_0__productSlider___default.a
    }
});

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configs_products_js__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_icons__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(70);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductSlider',
    props: ['bg'],
    data: function data() {
        var self = this;
        return {
            products: __WEBPACK_IMPORTED_MODULE_0__configs_products_js__["a" /* default */],
            swiperOption: {
                speed: 600,
                loop: false,
                effect: 'slide',
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    renderBullet: function renderBullet(index, className) {
                        return '<div class="' + className + ' swiper-pagination-bullet-custom"><div class="nav-image"><img src="' + self.products[index].secondaryImg + '"></div><span class="nav-title">' + self.products[index].name + '</span></div>';
                    }
                },
                on: {
                    slideChange: function slideChange(index) {
                        self.$store.commit('updateCurrentBg', self.products[this.activeIndex].bg);
                        self.$router.push(self.products[this.activeIndex].param);
                        self.$root.gaSend('product', 'click', self.products[this.activeIndex].param);
                    },
                    init: function init() {
                        self.$store.commit('updateCurrentBg', self.products[this.activeIndex].bg);
                        self.$root.gaSend('product', 'how', self.$route.params.id);
                        self.updCurrentSlide(self.$route.params.id, this);
                    }
                },
                breakpoints: {
                    1023: {
                        loop: false,
                        pagination: {
                            el: null
                        },
                        navigation: {
                            nextEl: '.next-slide',
                            prevEl: '.prev-slide'
                        }
                    }
                }
            }
        };
    },

    methods: {
        updCurrentSlide: function updCurrentSlide(id, swiper) {
            __WEBPACK_IMPORTED_MODULE_0__configs_products_js__["a" /* default */].forEach(function (item) {
                if (item.param == id) {
                    swiper.slideTo(__WEBPACK_IMPORTED_MODULE_0__configs_products_js__["a" /* default */].indexOf(item));
                }
            });
        }
    },
    computed: {
        swiper: function swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },
    components: {
        'arrow-next': __WEBPACK_IMPORTED_MODULE_1__assets_svg_icons__["a" /* default */].arrowNext,
        'arrow-prev': __WEBPACK_IMPORTED_MODULE_1__assets_svg_icons__["a" /* default */].arrowPrev
    },
    watch: {
        '$route': function $route(to, from) {
            this.$root.gaSend('product', 'click', to.params.id);
            this.updCurrentSlide(to.params.id, this.swiper);
        }
    }
});

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_icons__ = __webpack_require__(55);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BigView',
    props: {
        backgroundImg: String,
        icon: {
            type: String,
            required: true
        },
        countryName: {
            type: String,
            required: true
        },
        countryFlag: {
            type: String,
            required: true
        },
        titleNumber: {
            type: Number,
            required: true
        },
        titleText: {
            type: String,
            required: true
        },
        contentText: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_icons__ = __webpack_require__(55);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SmallView',
    props: {
        backgroundImg: String,
        icon: String,
        countryHome: {
            type: String,
            required: true
        },
        countryAway: {
            type: String,
            required: true
        },
        titleHome: {
            type: Object,
            required: true
        },
        titleAway: {
            type: Object,
            required: true
        },
        textHome: {
            type: String,
            required: true
        },
        textAway: {
            type: String,
            required: true
        }
    }
});

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


var URLS = {
    "vk": "https://vk.com/share.php?url=",
    "fb": "https://www.facebook.com/sharer/sharer.php?u=",
    "tw": "https://twitter.com/intent/tweet?text=&hashtags=&url=",
    "ok": "https://connect.ok.ru/dk?cmd=WidgetSharePreview&st.cmd=WidgetSharePreview&st._aid=ExternalShareWidget_SharePreview&st.shareUrl=",
    "tg": "https://telegram.me/share/url?url="
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'shareLink',
    props: {
        network: {
            type: [String],
            required: true
        },
        url: {
            type: [String],
            required: true
        },
        title: {
            type: [String],
            required: false,
            default: ''
        },
        description: {
            type: [String],
            required: false,
            default: ''
        },
        image: {
            type: [String],
            required: false,
            default: ''
        }
    },
    components: {},
    methods: {
        sharePopup: function sharePopup(url, width, height) {
            //  console.log(url);
            if (!width) width = 400;
            if (!height) height = 400;

            var share_window = window.open(url, '_blank', 'height=' + height + ',width=' + width + ',menubar=no,toolbar=no,location=no');
            var watch_timer = setInterval(function () {
                if (share_window.closed) {
                    clearInterval(watch_timer);
                    this.$emit('onShareClose');
                    return;
                }
            }, 200);
        },
        onShareStart: function onShareStart() {
            this.sharePopup(URLS[this.network] + encodeURIComponent(this.url), 550, 300);
        }
    }
});

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var banners = {
    1: {
        name: 'Swift 1',
        title: 'до <b>10</b> часов',
        desc: 'автономной работы',
        img: '/static/img/parts/swift/rek-bg.png',
        link: '/product/swift_1',
        className: 'swift_1'
    },
    2: {
        name: 'Swift 1',
        title: '<b>14”</b> Full HD IPS',
        desc: 'Дисплей',
        img: '/static/img/parts/swift/rek-bg.png',
        link: '/product/swift_1',
        className: 'swift_1'
    },
    3: {
        name: 'Swift 1',
        title: '<b>10</b> Windows',
        desc: 'Домашняя',
        img: '/static/img/parts/swift/rek-bg.png',
        link: '/product/swift_1',
        className: 'swift_1'
    },
    4: {
        name: 'Spin 1',
        title: '<b>11,6"</b> FHD IPS',
        desc: 'автономной работы',
        img: '/static/img/parts/swift/spin_1.png',
        link: '/product/spin_1',
        className: 'spin_1'
    },
    5: {
        name: 'Spin 1',
        title: '<b>4</b> положения',
        desc: 'для комфортной работы в любых условиях',
        img: '/static/img/parts/swift/spin_1.png',
        link: '/product/spin_1',
        className: 'spin_1'
    },
    6: {
        name: 'Swift 3',
        title: '<b>12</b> часов',
        desc: 'автономной работы',
        img: '/static/img/parts/swift/swift_3.png',
        link: '/product/swift_3',
        className: 'swift_3'
    },
    7: {
        name: 'Swift 3',
        title: '<b>14"</b> FULL HD IPS',
        desc: 'дисплей в корпусе 13,3’’',
        img: '/static/img/parts/swift/swift_3.png',
        link: '/product/swift_3',
        className: 'swift_3'
    },
    8: {
        name: 'Swift 5',
        title: '<b>14"</b> FULL HD IPS',
        desc: 'сенсорный дисплей в корпусе 13,3’’',
        img: '/static/img/parts/swift/swift_5.png',
        link: '/product/swift_5',
        className: 'swift_5'
    },
    9: {
        name: 'Swift 5',
        title: '<b>8</b> часов',
        desc: 'автономной работы',
        img: '/static/img/parts/swift/swift_5.png',
        link: '/product/swift_5',
        className: 'swift_5 center-swift'
    },
    10: {
        name: 'Swift 5',
        title: '<b>970</b> грамм',
        desc: 'вес ноутбука',
        img: '/static/img/parts/swift/swift_5.png',
        link: '/product/swift_5',
        className: 'swift_5'
    },
    11: {
        name: 'Spin 5',
        title: '<b>13</b> часов',
        desc: 'автономной работы',
        img: '/static/img/parts/swift/spin_5.png',
        link: '/product/spin_5',
        className: 'spin_5'
    },
    12: {
        name: 'Spin 5',
        title: '<b>13,3"</b> FHD IPS',
        desc: 'сенсорный дисплей',
        img: '/static/img/parts/swift/spin_5.png',
        link: '/product/spin_5',
        className: 'spin_5'
    }
};

/* harmony default export */ __webpack_exports__["a"] = (banners);

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    mainImg: '/static/img/pages/product/swift_1.png',
    secondaryImg: '/static/img/pages/product/swift_1.png',
    bg: '/static/img/pages/product/bg/swift_1_bg.jpg',
    name: 'Swift 1',
    param: 'swift_1',
    price: 'В МедиаМаркт за 30 989 руб.',
    link: 'https://www.mediamarkt.ru/item/1356828/acer-swift-sf113-31-p0am-nx-gpner-002-noutbuk',
    title: 'Портативный ноутбук в современном дизайне',
    description: "Стильный дизайн премиум-класса с функциональностью для повседневных задач. Мощный процессор, высокая продуктивность, долгое время автономной работы и быстрый запуск. Этот ноутбук станет незаменимым помощником.",
    features: [{
        img: 'case',
        title: 'Металлический<br> корпус'
    }, {
        img: 'clock',
        title: 'До 10 часов',
        description: 'автономной работы'
    }, {
        img: 'hd',
        title: '<b>14” Full HD IPS</b>',
        description: 'дисплей'
    }, {
        img: 'impress',
        title: 'Сканнер<br> отпечатка пальца'
    }, {
        img: 'windows',
        title: '<b>Windows 10</b>',
        description: 'Домашняя'
    }]
}, {
    mainImg: '/static/img/pages/product/spin_1.png',
    secondaryImg: '/static/img/pages/product/spin_1.png',
    bg: '/static/img/pages/product/bg/spin_1_bg.jpg',
    name: 'Spin 1',
    param: 'spin_1',
    price: 'В Эльдорадо за 26 990 руб.',
    link: 'https://www.eldorado.ru/cat/detail/71373454/',
    title: 'Высокая производительность весь день',
    description: 'Наслаждайтесь работой на новом потрясающем ноутбуке Spin 1 \n' + 'в любом положении благодаря повороту экрана на 360°.',
    features: [{
        img: 'case',
        title: 'Металлический<br> корпус'
    }, {
        img: 'processor',
        title: '<b>Процессоры <br>Intel</b>'
    }, {
        img: 'hd',
        title: '<b>11,6" FHD IPS</b>',
        description: 'сенсорный дисплей'
    }, {
        img: 'pen',
        description: 'Стилус в комплекте <br>' + 'с поддержкой Windows Ink'
    }, {
        img: 'windows',
        title: '<b>4 положения</b>',
        description: 'для комфортной работы <br>в любых условиях'
    }, {
        img: '',
        title: '',
        description: ''
    }]
}, {
    mainImg: '/static/img/pages/product/swift_3.png',
    secondaryImg: '/static/img/pages/product/swift_3.png',
    bg: '/static/img/pages/product/bg/swift_3_bg.jpg',
    name: 'Swift 3',
    param: 'swift_3',
    price: 'В М.Видео за 43 990 руб.',
    link: 'https://www.mvideo.ru/product-list-page-cls?q=SF314&region_id=1&limit=12',
    title: 'Элегантный и функциональный дизайн',
    description: 'Ноутбук идеально подходит для активного образа жизни. Высокая скорость операций, эффективность и мощность — все в одном устройстве. А его стильная металлическая рамка придает роскошному тонкому ноутбуку элегантность и никого не оставит равнодушным.',
    features: [{
        img: 'case',
        title: 'Металлический<br> корпус'
    }, {
        img: 'clock',
        title: '<b>12 часов</b>',
        description: 'автономной работы'
    }, {
        img: 'hd',
        title: '<b>14” Full HD IPS</b>',
        description: 'дисплей в корпусе 13.3"'
    }, {
        img: 'impress',
        title: 'Сканнер отпечатка пальца',
        description: 'с поддержкой Windows Hello'
    }, {
        img: '',
        title: '',
        description: ''
    }, {
        img: 'processor',
        title: '<b>Процессоры Intel Core</b>',
        description: '8-го поколения'
    }]
}, {
    mainImg: '/static/img/pages/product/swift_5.png',
    secondaryImg: '/static/img/pages/product/swift_5.png',
    bg: '/static/img/pages/product/bg/swift_5_bg.jpg',
    name: 'Swift 5',
    param: 'swift_5',
    price: 'В М.Видео от 86 590 руб.',
    link: 'https://www.mvideo.ru/product-list-page-cls?q=Sf514&region_id=1&limit=12',
    title: 'Новый чемпион в суперлегком весе',
    description: 'Ежедневная работа на этом ноутбуке будет в удовольствие благодаря мощной начинке. Суперкомпактный, суперлегкий и суперстильный - три супер составляющие успеха нового ультрабука Swift 5.',
    features: [{
        img: 'case',
        title: '<b>Металлический<br> корпус</b>',
        desccription: 'из сплавов Mg-Li и Mg-Al'
    }, {
        img: 'clock',
        title: '<b>8 часов</b>',
        description: 'автономной работы'
    }, {
        img: 'hd',
        title: '<b>14” Full HD IPS</b>',
        description: 'сенсорный дисплей <br>в корпусе 13.3"'
    }, {
        img: 'weigher',
        title: '<b>970 грамм</b>',
        description: 'вес ноутбука'
    }, {
        img: 'processor',
        title: '<b>Процессоры Intel Core</b>',
        description: '8-го поколения'
    }]
}, {
    mainImg: '/static/img/pages/product/spin_5.png',
    secondaryImg: '/static/img/pages/product/spin_5.png',
    bg: '/static/img/pages/product/bg/spin_5_bg.jpg',
    name: 'Spin 5',
    param: 'spin_5',
    price: 'В М.Видео от 68 490 руб.',
    link: 'https://www.mvideo.ru/product-list-page-cls?q=Acer+Spin5&region_id=1&limit=12',
    title: 'Удобство на 360 градусов',
    description: "Повышенная производительность вычислений и усовершенствованные аудио- и графические технологии. Наслаждайтесь универсальностью этого устройства \n" + "и приковывайте взгляды благодаря его стильному дизайну.",
    features: [{
        img: 'case',
        title: 'Трансформируемый <br>металлический корпус'
    }, {
        img: 'clock',
        title: '<b>13 часов</b>',
        description: 'автономной работы'
    }, {
        img: 'hd',
        title: '13.3” FHD IPS',
        description: 'сенсорный дисплей'
    }, {
        img: 'pen',
        description: 'Стилус в комплекте <br>с поддержкой Windows Ink'
    }, {
        img: 'processor',
        title: '<b>Процессоры Intel Core</b>',
        description: '8-го поколения'
    }]
}]);

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Index__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pages_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_product_productBase__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_product_productBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_product_productBase__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);




var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [{
        path: '/',
        name: 'Index',
        component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Index___default.a
    }, {
        path: '/product/:id',
        name: 'Products',
        component: __WEBPACK_IMPORTED_MODULE_3__components_pages_product_productBase___default.a
    }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(323);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.credentials = true;

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "apiUrl", function() { return apiUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "baseUrl", function() { return baseUrl; });
var apiUrl = function apiUrl(state) {
  return state.apiUrl;
};

var baseUrl = function baseUrl(state) {
  return state.baseUrl;
};

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutations__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__module__ = __webpack_require__(345);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.credentials = true;

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
    modules: __WEBPACK_IMPORTED_MODULE_7__module__["a" /* default */],
    state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* state */],
    getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
    actions: __WEBPACK_IMPORTED_MODULE_5__actions__,
    mutations: __WEBPACK_IMPORTED_MODULE_6__mutations__
});

window.store = store;

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_camelCase__);

var requireModule = __webpack_require__(675);
var modules = {};
requireModule.keys().forEach(function (fileName) {
    if (fileName === './index.js') return;
    var moduleName = __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase___default()(fileName.replace(/(\.\/|\.js)/g, ''));
    modules[moduleName] = requireModule(fileName).default;
});
/* harmony default export */ __webpack_exports__["a"] = (modules);

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(69);



var state = {
    matches: {},
    currentBg: '/static/img/pages/main/main_bg.png',
    menuState: false
};

var actions = {
    getMatches: function getMatches(_ref, params) {
        var dispatch = _ref.dispatch,
            commit = _ref.commit,
            getters = _ref.getters,
            rootGetters = _ref.rootGetters;

        var data = params ? params : { offset: 0, limit: 100 };
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(rootGetters['apiUrl'] + '/games/?limit=' + data.limit + '&offset=' + data.offset).then(function (response) {
                commit('updateMatches', response.body);
                resolve();
            }, function () {
                reject();
            });
        });
    }
};

var getters = {
    getMatches: function getMatches(state) {
        return state.matches;
    },
    getCurrentBg: function getCurrentBg(state) {
        return state.currentBg;
    },
    getMenuState: function getMenuState(state) {
        return state.menuState;
    }
};

var mutations = {
    updateMatches: function updateMatches(state, data) {
        state.matches = data;
    },
    updateCurrentBg: function updateCurrentBg(state, str) {
        state.currentBg = str;
    },
    updateMenuState: function updateMenuState(state, boolean) {
        state.menuState = boolean;
    }
};

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: false,
    actions: actions,
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(143);


/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


var Helpers = {
    supportsWEBP: function supportsWEBP() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var supportsWebp = function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                    var webpData, blob;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    if (self.createImageBitmap) {
                                        _context.next = 2;
                                        break;
                                    }

                                    return _context.abrupt('return', false);

                                case 2:
                                    webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
                                    _context.next = 5;
                                    return fetch(webpData).then(function (r) {
                                        return r.blob();
                                    });

                                case 5:
                                    blob = _context.sent;
                                    return _context.abrupt('return', createImageBitmap(blob).then(function () {
                                        return true;
                                    }, function () {
                                        return false;
                                    }));

                                case 7:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));

                return function supportsWebp() {
                    return _ref.apply(this, arguments);
                };
            }();

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return supportsWebp();

                        case 2:
                            if (!_context2.sent) {
                                _context2.next = 6;
                                break;
                            }

                            _context2.t0 = true;
                            _context2.next = 7;
                            break;

                        case 6:
                            _context2.t0 = false;

                        case 7:
                            return _context2.abrupt('return', _context2.t0);

                        case 8:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }))();
    },
    isMobile: function isMobile() {
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check || this.isIPAD() || window.innerWidth < 769;
    },
    isTouch: function isTouch() {
        var isMobile = false; //initiate as false
        // device detection
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;
        return isMobile;
    },
    iOS: function iOS() {
        var iDevices = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'];

        while (iDevices.length) {
            if (navigator.platform === iDevices.pop()) {
                return true;
            }
        }

        return false;
    },
    isIPAD: function isIPAD() {
        var ua = navigator.userAgent;
        return (/iPad/i.test(ua) || /iPhone OS 3_1_2/i.test(ua) || /iPhone OS 3_2_2/i.test(ua)
        );
    },
    get_browser_info: function get_browser_info() {
        var ua = navigator.userAgent,
            tem = void 0,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { name: 'IE ', version: tem[1] || '' };
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\bOPR\/(\d+)/);
            if (tem != null) {
                return { name: 'Opera', version: tem[1] };
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }
        return {
            name: M[0],
            version: M[1]
        };
    },
    getRandomInt: function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    },
    getRandomFromArray: function getRandomFromArray(array) {
        return array[getRandomInt(0, array.length - 1)];
    },
    declension: function declension(num, expressions) {
        var result = void 0;
        var count = num % 100;
        if (count >= 5 && count <= 20) {
            result = expressions['2'];
        } else {
            count = count % 10;
            if (count == 1) {
                result = expressions['0'];
            } else if (count >= 2 && count <= 4) {
                result = expressions['1'];
            } else {
                result = expressions['2'];
            }
        }
        return result;
    },
    isIE: function isIE() {
        var ua = window.navigator.userAgent;
        if (ua.indexOf('Edge/') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('MSIE ') > 0) {
            return true;
        } else {
            return false;
        }
    },
    ga: function (_ga) {
        function ga() {
            return _ga.apply(this, arguments);
        }

        ga.toString = function () {
            return _ga.toString();
        };

        return ga;
    }(function () {
        var analitics = {
            send: function send(category, action, label, id) {
                if (typeof ga !== 'undefined') {

                    if (typeof label !== 'undefined' && label !== '') {
                        if (id) ga('send', 'event', category, action, label, id);else ga('send', 'event', category, action, label);
                    } else {
                        ga('send', 'event', category, action);
                    }
                }
            }
        };
        return analitics;
    }),
    share: function share(network, link, callback) {
        switch (network) {
            case "vk":
                var img = encodeURIComponent(link + '/static/img/share.jpg');
                sharePopup("https://vk.com/share.php?url=" + link + '&image=' + img + '&title=Больше футбола', 550, 300, callback);
                break;
            case "fb":
                sharePopup('https://www.facebook.com/sharer/sharer.php?u=' + link, 550, 300, callback);
                break;
            case "tw":
                sharePopup("https://twitter.com/intent/tweet?original_referer=" + link + "&tw_p=tweetbutton&url=" + link, 550, 300, callback);
                break;
            case "ok":
                sharePopup("https://connect.ok.ru/dk?cmd=WidgetSharePreview&st.cmd=WidgetSharePreview&st._aid=ExternalShareWidget_SharePreview&st.shareUrl=" + link, 550, 300, callback);
                break;
            case "tg":
                sharePopup("https://telegram.me/share/url?url=" + link, 550, 300, callback);
                break;
        }

        function sharePopup(url, width, height, callback) {
            //  console.log(url);
            if (!width) width = 400;
            if (!height) height = 400;

            var uri_regex = new RegExp(window.location.host);
            var share_window = window.open(url, '_blank', 'height=' + height + ',width=' + width + ',menubar=no,toolbar=no,location=no');

            var watch_timer = setInterval(function () {
                if (share_window.closed) {
                    clearInterval(watch_timer);
                    if (typeof callback != 'undefined') {
                        callback();
                    }
                    return;
                }
            }, 200);
        }
    },

    isScrolledIntoView: function isScrolledIntoView(el) {
        var elemTop = el.getBoundingClientRect().top;
        var elemBottom = el.getBoundingClientRect().bottom;
        var elHeight = elemBottom - elemTop;
        //return (elemTop >= -window.innerHeight/2) && (elemTop <= window.innerHeight/2) && (elemBottom >= window.innerHeight/2) && (elemBottom <= 3*window.innerHeight/2);
        return elemBottom <= elHeight;
    },

    dLayer: function dLayer(data) {
        if ('dataLayer' in window) {
            dataLayer.push(data);
        }
    },

    getOS: function getOS() {
        var userAgent = window.navigator.userAgent,
            platform = window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            os = null;

        if (macosPlatforms.indexOf(platform) !== -1) {
            os = 'Mac OS';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            os = 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = 'Windows';
        } else if (/Android/.test(userAgent)) {
            os = 'Android';
        } else if (!os && /Linux/.test(platform)) {
            os = 'Linux';
        }

        return os;
    },
    isMac: function isMac() {
        return this.getOS() === 'Mac OS';
    },
    getLang: function getLang() {
        var lang = localStorage.getItem('DEVELUP_LANG');
        var browserLang = navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage;
        browserLang = browserLang.indexOf('ru') >= 0 ? 'ru' : 'en';
        return lang ? lang : browserLang;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Helpers);

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__socialShare__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__socialShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__socialShare__);


var ShareLink = {
    install: function install(Vue, option) {
        Vue.component(__WEBPACK_IMPORTED_MODULE_0__socialShare___default.a.name, __WEBPACK_IMPORTED_MODULE_0__socialShare___default.a);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (ShareLink);

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dictionary; });

var dictionary = {
    ru: {
        custom: {}
    },
    en: {
        custom: {}
    }
};

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_camelCase__);


var requireModule = __webpack_require__(674);
var modules = {};

requireModule.keys().forEach(function (fileName) {
    if (fileName === './index.js') return;
    var moduleName = __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase___default()(fileName.replace(/(\.\/|\.svg)/g, ''));
    modules[moduleName] = requireModule(fileName);
});

/* harmony default export */ __webpack_exports__["a"] = (modules);

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 201,
	"./af.js": 201,
	"./ar": 208,
	"./ar-dz": 202,
	"./ar-dz.js": 202,
	"./ar-kw": 203,
	"./ar-kw.js": 203,
	"./ar-ly": 204,
	"./ar-ly.js": 204,
	"./ar-ma": 205,
	"./ar-ma.js": 205,
	"./ar-sa": 206,
	"./ar-sa.js": 206,
	"./ar-tn": 207,
	"./ar-tn.js": 207,
	"./ar.js": 208,
	"./az": 209,
	"./az.js": 209,
	"./be": 210,
	"./be.js": 210,
	"./bg": 211,
	"./bg.js": 211,
	"./bm": 212,
	"./bm.js": 212,
	"./bn": 213,
	"./bn.js": 213,
	"./bo": 214,
	"./bo.js": 214,
	"./br": 215,
	"./br.js": 215,
	"./bs": 216,
	"./bs.js": 216,
	"./ca": 217,
	"./ca.js": 217,
	"./cs": 218,
	"./cs.js": 218,
	"./cv": 219,
	"./cv.js": 219,
	"./cy": 220,
	"./cy.js": 220,
	"./da": 221,
	"./da.js": 221,
	"./de": 224,
	"./de-at": 222,
	"./de-at.js": 222,
	"./de-ch": 223,
	"./de-ch.js": 223,
	"./de.js": 224,
	"./dv": 225,
	"./dv.js": 225,
	"./el": 226,
	"./el.js": 226,
	"./en-au": 227,
	"./en-au.js": 227,
	"./en-ca": 228,
	"./en-ca.js": 228,
	"./en-gb": 229,
	"./en-gb.js": 229,
	"./en-ie": 230,
	"./en-ie.js": 230,
	"./en-il": 231,
	"./en-il.js": 231,
	"./en-nz": 232,
	"./en-nz.js": 232,
	"./eo": 233,
	"./eo.js": 233,
	"./es": 236,
	"./es-do": 234,
	"./es-do.js": 234,
	"./es-us": 235,
	"./es-us.js": 235,
	"./es.js": 236,
	"./et": 237,
	"./et.js": 237,
	"./eu": 238,
	"./eu.js": 238,
	"./fa": 239,
	"./fa.js": 239,
	"./fi": 240,
	"./fi.js": 240,
	"./fo": 241,
	"./fo.js": 241,
	"./fr": 244,
	"./fr-ca": 242,
	"./fr-ca.js": 242,
	"./fr-ch": 243,
	"./fr-ch.js": 243,
	"./fr.js": 244,
	"./fy": 245,
	"./fy.js": 245,
	"./gd": 246,
	"./gd.js": 246,
	"./gl": 247,
	"./gl.js": 247,
	"./gom-latn": 248,
	"./gom-latn.js": 248,
	"./gu": 249,
	"./gu.js": 249,
	"./he": 250,
	"./he.js": 250,
	"./hi": 251,
	"./hi.js": 251,
	"./hr": 252,
	"./hr.js": 252,
	"./hu": 253,
	"./hu.js": 253,
	"./hy-am": 254,
	"./hy-am.js": 254,
	"./id": 255,
	"./id.js": 255,
	"./is": 256,
	"./is.js": 256,
	"./it": 257,
	"./it.js": 257,
	"./ja": 258,
	"./ja.js": 258,
	"./jv": 259,
	"./jv.js": 259,
	"./ka": 260,
	"./ka.js": 260,
	"./kk": 261,
	"./kk.js": 261,
	"./km": 262,
	"./km.js": 262,
	"./kn": 263,
	"./kn.js": 263,
	"./ko": 264,
	"./ko.js": 264,
	"./ky": 265,
	"./ky.js": 265,
	"./lb": 266,
	"./lb.js": 266,
	"./lo": 267,
	"./lo.js": 267,
	"./lt": 268,
	"./lt.js": 268,
	"./lv": 269,
	"./lv.js": 269,
	"./me": 270,
	"./me.js": 270,
	"./mi": 271,
	"./mi.js": 271,
	"./mk": 272,
	"./mk.js": 272,
	"./ml": 273,
	"./ml.js": 273,
	"./mn": 274,
	"./mn.js": 274,
	"./mr": 275,
	"./mr.js": 275,
	"./ms": 277,
	"./ms-my": 276,
	"./ms-my.js": 276,
	"./ms.js": 277,
	"./mt": 278,
	"./mt.js": 278,
	"./my": 279,
	"./my.js": 279,
	"./nb": 280,
	"./nb.js": 280,
	"./ne": 281,
	"./ne.js": 281,
	"./nl": 283,
	"./nl-be": 282,
	"./nl-be.js": 282,
	"./nl.js": 283,
	"./nn": 284,
	"./nn.js": 284,
	"./pa-in": 285,
	"./pa-in.js": 285,
	"./pl": 286,
	"./pl.js": 286,
	"./pt": 288,
	"./pt-br": 287,
	"./pt-br.js": 287,
	"./pt.js": 288,
	"./ro": 289,
	"./ro.js": 289,
	"./ru": 135,
	"./ru.js": 135,
	"./sd": 290,
	"./sd.js": 290,
	"./se": 291,
	"./se.js": 291,
	"./si": 292,
	"./si.js": 292,
	"./sk": 293,
	"./sk.js": 293,
	"./sl": 294,
	"./sl.js": 294,
	"./sq": 295,
	"./sq.js": 295,
	"./sr": 297,
	"./sr-cyrl": 296,
	"./sr-cyrl.js": 296,
	"./sr.js": 297,
	"./ss": 298,
	"./ss.js": 298,
	"./sv": 299,
	"./sv.js": 299,
	"./sw": 300,
	"./sw.js": 300,
	"./ta": 301,
	"./ta.js": 301,
	"./te": 302,
	"./te.js": 302,
	"./tet": 303,
	"./tet.js": 303,
	"./tg": 304,
	"./tg.js": 304,
	"./th": 305,
	"./th.js": 305,
	"./tl-ph": 306,
	"./tl-ph.js": 306,
	"./tlh": 307,
	"./tlh.js": 307,
	"./tr": 308,
	"./tr.js": 308,
	"./tzl": 309,
	"./tzl.js": 309,
	"./tzm": 311,
	"./tzm-latn": 310,
	"./tzm-latn.js": 310,
	"./tzm.js": 311,
	"./ug-cn": 312,
	"./ug-cn.js": 312,
	"./uk": 313,
	"./uk.js": 313,
	"./ur": 314,
	"./ur.js": 314,
	"./uz": 316,
	"./uz-latn": 315,
	"./uz-latn.js": 315,
	"./uz.js": 316,
	"./vi": 317,
	"./vi.js": 317,
	"./x-pseudo": 318,
	"./x-pseudo.js": 318,
	"./yo": 319,
	"./yo.js": 319,
	"./zh-cn": 320,
	"./zh-cn.js": 320,
	"./zh-hk": 321,
	"./zh-hk.js": 321,
	"./zh-tw": 322,
	"./zh-tw.js": 322
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 621;

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(649),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(646),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(641),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(644),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(643),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(650),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(642),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(647),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(648),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(645),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 641:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'is-mobile': _vm.$root.isMobile
    },
    style: ({
      fontSize: _vm.fSize + 'px'
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-slider"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.products), function(product, key) {
    return _c('swiper-slide', {
      key: key
    }, [_c('div', {
      staticClass: "product__inner"
    }, [_c('div', {
      staticClass: "product__leftside"
    }, [_c('a', {
      staticClass: "acer-logo",
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/pages/product/acer-logo.png",
        "alt": "acer"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "product__img"
    }, [_c('img', {
      attrs: {
        "src": product.mainImg,
        "alt": product.mainImg
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "product__content product__content--nomg"
    }, [_c('h2', {
      staticClass: "product__name"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(product.name)
      }
    })]), _vm._v(" "), _c('h3', {
      staticClass: "product__price"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(product.price)
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "product__link btn",
      attrs: {
        "href": product.link,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          _vm.$root.gaSend('product', 'click', product.name)
        }
      }
    }, [_vm._v("Купить")])])]), _vm._v(" "), _c('div', {
      staticClass: "product__rightside",
      style: ({
        'backgroundImage': (_vm.$root.isMobile) ? 'url(' + _vm.bg + ')' : ''
      })
    }, [_c('div', {
      staticClass: "product__content"
    }, [_c('h1', {
      staticClass: "product__title"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(product.title)
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "product__description",
      domProps: {
        "innerHTML": _vm._s(product.description)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "product__features"
    }, _vm._l((product.features), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "product__features-item"
      }, [(item.img) ? _c('img', {
        attrs: {
          "src": '/static/svg/icons/' + item.img + '.svg',
          "alt": "icon"
        }
      }) : _vm._e(), _vm._v(" "), (item.title) ? _c('h3', {
        staticClass: "item-title"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      })]) : _vm._e(), _vm._v(" "), (item.description) ? _c('h4', {
        staticClass: "item-undertitle"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.description)
        }
      })]) : _vm._e()])
    }))])])])
  })), _vm._v(" "), (_vm.$root.isMobile) ? _c('div', {
    staticClass: "next-slide"
  }, [_c('arrow-next')], 1) : _vm._e(), _vm._v(" "), (_vm.$root.isMobile) ? _c('div', {
    staticClass: "prev-slide"
  }, [_c('arrow-prev')], 1) : _vm._e(), _vm._v(" "), (!_vm.$root.isMobile) ? _c('div', {
    staticClass: "product__navigation navi"
  }, [_c('div', {
    staticClass: "navi__leftside"
  }, [_c('div', {
    staticClass: "swiper-pagination swiper-pagination-bullets",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })]), _vm._v(" "), _c('div', {
    staticClass: "navi__rightside"
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-index",
    class: {
      'hidden-scroll': _vm.menuState
    },
    style: ({
      'backgroundImage': 'url(' + _vm.bg + ')'
    }),
    attrs: {
      "id": "index"
    },
    on: {
      "scroll": _vm.changeMenuClass
    }
  }, [_c('div', {
    ref: "content",
    staticClass: "page-index-content"
  }, [_c('preview-app', {
    attrs: {
      "matches": _vm.matches
    },
    on: {
      "changedStatistic": _vm.getStatistic
    }
  }), _vm._v(" "), (_vm.statistic) ? _c('div', {
    staticClass: "wrapper"
  }, [(_vm.$root.isMobile) ? _c('div', {
    staticClass: "mobile-show"
  }, [_c('smallView', {
    staticClass: "first",
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_3_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_3_1_count, ['удачную обводку', 'удачные обводки', 'удачных обводок'])
      },
      "titleAway": {
        number: _vm.statistic.b_right_3_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_3_2_count, ['удачную обводку', 'удачные обводки', 'удачных обводок'])
      },
      "textHome": _vm.statistic.b_right_3_1_text,
      "textAway": _vm.statistic.b_right_3_2_text,
      "icon": 'pass'
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "swift",
    class: _vm.banners[_vm.statistic.banner_right_1].className,
    attrs: {
      "to": _vm.banners[_vm.statistic.banner_right_1].link
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvent('main', 'click', _vm.banners[_vm.statistic.banner_left_1].className)
      }
    }
  }, [_c('div', {
    staticClass: "overlay",
    style: ({
      backgroundImage: 'url(' + _vm.banners[_vm.statistic.banner_right_1].img + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "product-body"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_right_1].name))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.banners[_vm.statistic.banner_right_1].title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "descr"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_right_1].desc))])]), _vm._v(" "), _c('div', {
    staticClass: "more"
  }, [_c('span', [_vm._v("Узнать больше")])])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "leftside"
  }, [_c('bigView', {
    attrs: {
      "countryName": _vm.currentMatch.fkParticipants1.name,
      "countryFlag": _vm.currentMatch.fkParticipants1.image,
      "icon": 'move',
      "titleNumber": _vm.statistic.b_left_1_count,
      "titleText": _vm.$root.Helpers.declension(_vm.statistic.b_left_1_count, ['передачу', 'передачи', 'передач']),
      "contentText": _vm.statistic.b_left_1_text
    }
  }), _vm._v(" "), _c('bigView', {
    attrs: {
      "countryName": _vm.currentMatch.fkParticipants2.name,
      "countryFlag": _vm.currentMatch.fkParticipants2.image,
      "icon": 'move',
      "titleNumber": _vm.statistic.b_left_2_count,
      "titleText": _vm.$root.Helpers.declension(_vm.statistic.b_left_2_count, ['передачу', 'передачи', 'передач']),
      "contentText": _vm.statistic.b_left_2_text
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rightside"
  }, [_c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_1_1_count + '%',
        hasBr: true,
        text: 'единоборств'
      },
      "titleAway": {
        number: _vm.statistic.b_right_1_2_count + '%',
        hasBr: true,
        text: 'выигранных единоборств'
      },
      "textHome": _vm.statistic.b_right_1_1_text,
      "textAway": _vm.statistic.b_right_1_2_text
    }
  }), _vm._v(" "), _c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_2_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_2_1_count, ['передачу', 'передачи', 'передач'])
      },
      "titleAway": {
        number: _vm.statistic.b_right_2_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_2_2_count, ['передачу', 'передачи', 'передач'])
      },
      "textHome": _vm.statistic.b_right_2_1_text,
      "textAway": _vm.statistic.b_right_2_2_text,
      "icon": 'exchange'
    }
  }), _vm._v(" "), (!_vm.$root.isMobile) ? _c('div', {
    staticClass: "mobile-hidden"
  }, [_c('router-link', {
    staticClass: "swift",
    class: _vm.banners[_vm.statistic.banner_right_1].className,
    attrs: {
      "to": _vm.banners[_vm.statistic.banner_right_1].link
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvent('main', 'click', _vm.banners[_vm.statistic.banner_left_1].className)
      }
    }
  }, [_c('div', {
    staticClass: "overlay",
    style: ({
      backgroundImage: 'url(' + _vm.banners[_vm.statistic.banner_right_1].img + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "product-body"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_right_1].name))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.banners[_vm.statistic.banner_right_1].title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "descr"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_right_1].desc))])]), _vm._v(" "), _c('div', {
    staticClass: "more"
  }, [_c('span', [_vm._v("Узнать больше")])])])]), _vm._v(" "), _c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_3_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_3_1_count, ['удачную обводку', 'удачные обводки', 'удачных обводок'])
      },
      "titleAway": {
        number: _vm.statistic.b_right_3_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_3_2_count, ['удачную обводку', 'удачные обводки', 'удачных обводок'])
      },
      "textHome": _vm.statistic.b_right_3_1_text,
      "textAway": _vm.statistic.b_right_3_2_text,
      "icon": 'pass'
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "leftside"
  }, [_c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_left_3_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_left_3_1_count, ['удар', 'удара', 'ударов'])
      },
      "titleAway": {
        number: _vm.statistic.b_left_3_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_left_3_2_count, ['удар', 'удара', 'ударов'])
      },
      "textHome": _vm.statistic.b_left_3_1_text,
      "textAway": _vm.statistic.b_left_3_2_text,
      "icon": 'ball'
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "swift swift--small",
    class: _vm.banners[_vm.statistic.banner_left_1].className,
    attrs: {
      "to": _vm.banners[_vm.statistic.banner_left_1].link
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvent('main', 'click', _vm.banners[_vm.statistic.banner_left_1].className)
      }
    }
  }, [_c('div', {
    staticClass: "overlay",
    style: ({
      backgroundImage: 'url(' + _vm.banners[_vm.statistic.banner_left_1].img + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "product-body"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_left_1].name))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.banners[_vm.statistic.banner_left_1].title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "descr"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_left_1].desc))])]), _vm._v(" "), _c('div', {
    staticClass: "more"
  }, [_c('span', [_vm._v("Узнать больше")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "rightside"
  }, [_c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_4_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_4_1_count, ['удар', 'удара', 'ударов'])
      },
      "titleAway": {
        number: _vm.statistic.b_right_4_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_4_2_count, ['удар', 'удара', 'ударов'])
      },
      "textHome": _vm.statistic.b_right_4_1_text,
      "textAway": _vm.statistic.b_right_4_2_text,
      "icon": 'kickGreen'
    }
  }), _vm._v(" "), _c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_5_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_5_1_count, ['острую передачу', 'острых передачи', 'острых передач'])
      },
      "titleAway": {
        number: _vm.statistic.b_right_5_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_5_2_count, ['острую передачу', 'острых передачи', 'острых передач'])
      },
      "textHome": _vm.statistic.b_right_5_1_text,
      "textAway": _vm.statistic.b_right_5_2_text,
      "backgroundImg": 'url(/static/img/pages/main/block_img_2.png)'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "leftside"
  }, [_c('bigView', {
    attrs: {
      "countryName": _vm.currentMatch.fkParticipants1.name,
      "countryFlag": _vm.currentMatch.fkParticipants1.image,
      "icon": 'move',
      "titleNumber": _vm.statistic.b_left_4_count,
      "titleText": _vm.$root.Helpers.declension(_vm.statistic.b_left_4_count, ['ключевую передачу', 'ключевые передачи', 'ключевых передач']),
      "contentText": _vm.statistic.b_left_4_text,
      "backgroundImg": 'url(/static/img/pages/main/block_img_1.png)'
    }
  }), _vm._v(" "), _c('bigView', {
    attrs: {
      "countryName": _vm.currentMatch.fkParticipants2.name,
      "countryFlag": _vm.currentMatch.fkParticipants2.image,
      "icon": 'move',
      "titleNumber": _vm.statistic.b_left_5_count,
      "titleText": _vm.$root.Helpers.declension(_vm.statistic.b_left_5_count, ['ключевую передачу', 'ключевые передачи', 'ключевых передач']),
      "contentText": _vm.statistic.b_left_5_text,
      "backgroundImg": 'url(/static/img/pages/main/block_img_1.png)'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rightside"
  }, [_c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_6_1_count + '%',
        hasBr: false,
        text: 'точных передач'
      },
      "titleAway": {
        number: _vm.statistic.b_right_6_2_count + '%',
        hasBr: false,
        text: 'точных передач'
      },
      "textHome": _vm.statistic.b_right_6_1_text,
      "textAway": _vm.statistic.b_right_6_2_text
    }
  }), _vm._v(" "), _c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_7_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_7_1_count, ['точную передачу', 'точные передачи', 'точных передач'])
      },
      "titleAway": {
        number: _vm.statistic.b_right_7_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_7_2_count, ['точную передачу', 'точные передачи', 'точных передач'])
      },
      "textHome": _vm.statistic.b_right_7_1_text,
      "textAway": _vm.statistic.b_right_7_2_text,
      "icon": 'kickRose'
    }
  }), _vm._v(" "), _c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_8_1_count + '%',
        hasBr: true,
        text: 'удачных отборов'
      },
      "titleAway": {
        number: _vm.statistic.b_right_8_2_count + '%',
        hasBr: true,
        text: 'удачных отборов'
      },
      "textHome": _vm.statistic.b_right_8_1_text,
      "textAway": _vm.statistic.b_right_8_2_text
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "swift",
    class: _vm.banners[_vm.statistic.banner_right_2].className,
    attrs: {
      "to": _vm.banners[_vm.statistic.banner_right_2].link
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvent('main', 'click', _vm.banners[_vm.statistic.banner_left_1].className)
      }
    }
  }, [_c('div', {
    staticClass: "overlay",
    style: ({
      backgroundImage: 'url(' + _vm.banners[_vm.statistic.banner_right_2].img + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "product-body"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_right_2].name))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.banners[_vm.statistic.banner_right_2].title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "descr"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_right_2].desc))])]), _vm._v(" "), _c('div', {
    staticClass: "more"
  }, [_c('span', [_vm._v("Узнать больше")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "leftside"
  }, [_c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_left_6_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_left_6_1_count, ['потерю', 'потери', 'потерь'])
      },
      "titleAway": {
        number: _vm.statistic.b_left_6_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_left_6_2_count, ['потерю', 'потери', 'потерь'])
      },
      "textHome": _vm.statistic.b_left_6_1_text,
      "textAway": _vm.statistic.b_left_6_2_text,
      "icon": 'kickRose'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rightside"
  }, [_c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_9_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_9_1_count, ['удачную обводку', 'удачных обводки', 'удачных обводок'])
      },
      "titleAway": {
        number: _vm.statistic.b_right_9_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_9_2_count, ['удачную обводку', 'удачных обводки', 'удачных обводок'])
      },
      "textHome": _vm.statistic.b_right_9_1_text,
      "textAway": _vm.statistic.b_right_9_2_text,
      "icon": 'tackle'
    }
  })], 1)]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview"
  }, [(_vm.$root.isMobile) ? _c('span', {
    staticClass: "menu-disclaimer"
  }, [_vm._v("\n        СПЕЦИАЛЬНЫЙ ПРОЕКТ\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "preview-cols"
  }, [(!_vm.$root.isMobile) ? _c('div', {
    staticClass: "preview-col leftside"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _c('div', {
    staticClass: "preview-col leftside"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), (_vm.matches.items) ? _c('div', {
    staticClass: "preview-col rightside"
  }, [_c('div', {
    staticClass: "top-slider"
  }, [_c('swiper', {
    ref: "top-slider",
    attrs: {
      "options": _vm.topSliderOptions
    },
    on: {
      "slideChange": _vm.getActiveIndex,
      "init": _vm.getActiveIndex
    }
  }, _vm._l((_vm.matches.items), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "top-slider-item"
    }, [_c('div', {
      staticClass: "top-slider-item-command"
    }, [_c('div', {
      staticClass: "country-img"
    }, [_c('img', {
      attrs: {
        "src": item.fkParticipants1.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "item-title"
    }, [_vm._v("Сборная")]), _vm._v(" "), _c('span', {
      staticClass: "country-name"
    }, [_vm._v(_vm._s(item.fkParticipants1.name))])]), _vm._v(" "), _c('div', {
      staticClass: "total"
    }, [_c('span', [_vm._v(_vm._s(item.fkParticipants1.goals))]), _vm._v(" "), _c('span', [_vm._v("X")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.fkParticipants2.goals))])]), _vm._v(" "), _c('div', {
      staticClass: "top-slider-item-command"
    }, [_c('div', {
      staticClass: "country-img"
    }, [_c('img', {
      attrs: {
        "src": item.fkParticipants2.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "item-title"
    }, [_vm._v("Сборная")]), _vm._v(" "), _c('span', {
      staticClass: "country-name"
    }, [_vm._v(_vm._s(item.fkParticipants2.name))])])])])
  }))], 1), _vm._v(" "), (!_vm.$root.isMobile) ? _c('div', {
    staticClass: "top-slider-info"
  }, [_c('div', {
    staticClass: "top-slider-datetime"
  }, [_c('div', {
    staticClass: "date"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('calendar')], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.date))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('watch')], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.time))])])]), _vm._v(" "), _c('div', {
    staticClass: "top-slider-nav"
  }, [_c('a', {
    staticClass: "top-prev-slide",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.$root.gaSend('main', 'click', 'day slider')
      }
    }
  }, [_c('arrow-prev')], 1), _vm._v(" "), _c('a', {
    staticClass: "top-next-slide",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.$root.gaSend('main', 'click', 'day slider')
      }
    }
  }, [_c('arrow-next')], 1)])]) : _vm._e(), _vm._v(" "), (_vm.menuState || !_vm.$root.isMobile) ? _c('div', {
    staticClass: "navigation-slider"
  }, [_c('swiper', {
    ref: "navigation-slider",
    attrs: {
      "options": _vm.navigationSliderOptions
    }
  }, _vm._l((_vm.matches.items), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      class: {
        'active-item': _vm.currentIndex == index
      }
    }, [_c('div', {
      staticClass: "navigation-slider-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.currentIndex = index
        }
      }
    }, [_c('div', {
      staticClass: "navigation-slider-item-command"
    }, [_c('div', {
      staticClass: "country-img"
    }, [_c('img', {
      attrs: {
        "src": item.fkParticipants1.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "country-name"
    }, [_vm._v(_vm._s(item.fkParticipants1.name))])]), _vm._v(" "), _c('span', {
      staticClass: "delimiter"
    }, [_vm._v("X")]), _vm._v(" "), _c('div', {
      staticClass: "navigation-slider-item-command"
    }, [_c('div', {
      staticClass: "country-img"
    }, [_c('img', {
      attrs: {
        "src": item.fkParticipants2.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "country-name"
    }, [_vm._v(_vm._s(item.fkParticipants2.name))])])])])
  })), _vm._v(" "), (!_vm.$root.isMobile) ? _c('div', {
    staticClass: "navigation-slider-arrows"
  }, [_c('a', {
    staticClass: "navigation-prev-slide",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.$root.gaSend('main', 'click', 'all slider')
      }
    }
  }, [_c('arrow-prev')], 1), _vm._v(" "), _c('a', {
    staticClass: "navigation-next-slide",
    attrs: {
      "href": "#"
    }
  }, [_c('arrow-next')], 1)]) : _vm._e()], 1) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("\n                БОЛЬШЕ "), _c('br'), _vm._v("     ФУТБОЛА\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-text"
  }, [_c('p', [_vm._v("\n                    Редакция «Чемпионата» собирает для вас интересную статистику самых зрелищных матчей главного футбольного события года. Следите за ходом турнира на проекте «Больше футбола» и будьте в курсе всех деталей!\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("\n                БОЛЬШЕ "), _c('br'), _vm._v("  ФУТБОЛА\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-text"
  }, [_c('p', [_vm._v("\n                    Редакция «Чемпионата» собирает для вас интересную статистику самых зрелищных матчей главного футбольного события года. Следите за ходом турнира на проекте «Больше футбола» и будьте в курсе всех деталей!\n                ")])])
}]}

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onShareStart($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('menu', {
    class: ( _obj = {
      'none-border': _vm.$route.name != 'Index'
    }, _obj[_vm.menuClass] = [_vm.menuClass], _obj )
  }, [_c('a', {
    staticClass: "menu-logo",
    attrs: {
      "href": "https://www.championat.com/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.$root.gaSend('main', 'click', 'championat')
      }
    }
  }, [_c('logo-app')], 1), _vm._v(" "), (_vm.$route.name != 'Index') ? _c('router-link', {
    staticClass: "back",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$root.gaSend('main', 'click', 'championat')
      }
    }
  }, [_c('span', [_vm._v("\n            Вернуться\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.$root.isMobile && _vm.$route.name == 'Index') ? _c('a', {
    staticClass: "menu-btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.stateMenu = !_vm.stateMenu
      }
    }
  }, [(!_vm.stateMenu) ? _c('menu-app', {
    staticClass: "menu-icon"
  }) : _c('menu-close', {
    staticClass: "close-icon"
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.$root.isMobile) ? _c('span', {
    staticClass: "menu-disclaimer"
  }, [_vm._v("\n        СПЕЦИАЛЬНЫЙ ПРОЕКТ\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-share"
  }, [_c('div', {
    staticClass: "share-links"
  }, [_c('ul', _vm._l((_vm.shareLinks), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$root.Helpers.share(item.network, _vm.shareUrl(), _vm.toMain()), _vm.$root.gaSend('main', 'click', item.network)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })])])
  }))]), _vm._v(" "), _c('heart-app')], 1)], 1)
  var _obj;
},staticRenderFns: []}

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bigView",
    style: ({
      'backgroundImage': _vm.backgroundImg ? _vm.backgroundImg : '',
      'backgroundColor': _vm.backgroundImg ? '#141722' : ''
    })
  }, [(_vm.icon) ? _c('div', {
    staticClass: "bigView__icon"
  }, [_c('img', {
    attrs: {
      "src": '/static/svg/icons/' + _vm.icon + '.svg',
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bigView__country"
  }, [_c('span', {
    staticClass: "bigView__country-name",
    domProps: {
      "innerHTML": _vm._s(_vm.countryName)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bigView__country-flag"
  }, [_c('img', {
    attrs: {
      "src": _vm.countryFlag,
      "alt": _vm.countryName
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "bigView__title"
  }, [_c('span', {
    staticClass: "bigView__title-number",
    domProps: {
      "innerHTML": _vm._s(_vm.titleNumber)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bigView__title-text",
    domProps: {
      "innerHTML": _vm._s(_vm.titleText)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bigView__text",
    domProps: {
      "innerHTML": _vm._s(_vm.contentText)
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "smallView view",
    class: {
      hasIcon: _vm.icon
    },
    style: ({
      'backgroundImage': _vm.backgroundImg ? _vm.backgroundImg : '',
      'backgroundColor': _vm.backgroundImg ? '#141722' : ''
    })
  }, [_c('div', {
    staticClass: "home"
  }, [(_vm.icon) ? _c('div', {
    staticClass: "smallView__icon"
  }, [_c('img', {
    attrs: {
      "src": '/static/svg/icons/' + _vm.icon + '.svg',
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "smallView__country"
  }, [_c('img', {
    attrs: {
      "src": _vm.countryHome,
      "alt": _vm.countryHome
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "smallView__title"
  }, [_c('span', {
    staticClass: "smallView__title-number",
    domProps: {
      "innerHTML": _vm._s(_vm.titleHome.number)
    }
  }), (_vm.titleHome.hasBr) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "smallView__title-text",
    domProps: {
      "innerHTML": _vm._s(_vm.titleHome.text)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "smallView__text",
    domProps: {
      "innerHTML": _vm._s(_vm.textHome)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "away"
  }, [_c('div', {
    staticClass: "smallView__country"
  }, [_c('img', {
    attrs: {
      "src": _vm.countryAway,
      "alt": _vm.countryAway
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "smallView__title"
  }, [_c('span', {
    staticClass: "smallView__title-number",
    domProps: {
      "innerHTML": _vm._s(_vm.titleAway.number)
    }
  }), (_vm.titleAway.hasBr) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "smallView__title-text",
    domProps: {
      "innerHTML": _vm._s(_vm.titleAway.text)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "smallView__text",
    domProps: {
      "innerHTML": _vm._s(_vm.textAway)
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Resize', {
    ref: "app",
    staticClass: "app-layout",
    attrs: {
      "id": "app"
    }
  }, [_c('menu-app', {
    attrs: {
      "menuClass": _vm.menuClass
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "id": "content"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    ref: "page",
    attrs: {
      "supportsWEBP": _vm.supportsWEBP,
      "bg": _vm.getCurrentBg
    },
    on: {
      "changeMenuClass": _vm.changeMenuClass
    }
  })], 1)], 1), _vm._v(" "), (_vm.$root.isMobile) ? _c('a', {
    staticClass: "to-top",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toTop($event)
      }
    }
  }, [_c('to-top')], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-product",
    style: ({
      'backgroundImage': (!_vm.$root.isMobile) ? 'url(' + _vm.bg + ')' : ''
    })
  }, [_c('productSlider', {
    attrs: {
      "bg": _vm.bg
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 653:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 31.5 56"><path fill="#fff" d="M1 51.4c-.5.5-.8 1.2-.8 1.9 0 1.5 1.2 2.7 2.7 2.7.7 0 1.5-.3 2-.8l25.9-25.3c1.1-1 1.1-2.7 0-3.8L4.7.9C3.7-.2 2-.3.8.7S-.4 3.4.6 4.5l.2.2 21.3 20.6 2.6 2.6-2.6 2.7L1 51.4z"/></svg>'};

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 31.5 56"><path fill="#fff" d="M.8 26.1c-1.1 1-1.1 2.7 0 3.8l26 25.3c1 1.1 2.7 1.2 3.9.2 1.1-1 1.2-2.7.2-3.8l-.2-.2L9.4 30.6 6.8 28l2.6-2.7L30.6 4.6c.5-.5.8-1.2.9-1.9 0-1.5-1.2-2.7-2.7-2.7-.7 0-1.5.3-2 .8L.8 26.1z"/></svg>'};

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 42 41"><path fill="#9fa8b8" d="M1 12h40v2H1z"/><path fill="none" stroke="#9fa8b8" stroke-width="2" stroke-miterlimit="10" d="M7 7v2h5V7M30 7v2h5V7"/><path fill="none" d="M39 6h-5V2h-3v4H11V2H8v4H3c-.6 0-1 .4-1 1v31c0 .6.4 1 1 1h36c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1zM11 32H7v-2h4v2zm0-5H7v-2h4v2zm8 5h-4v-2h4v2zm0-5h-4v-2h4v2zm0-5h-4v-2h4v2zm8 10h-4v-2h4v2zm0-5h-4v-2h4v2zm0-5h-4v-2h4v2zm8 5h-4v-2h4v2zm0-5h-4v-2h4v2z"/><path fill="#9fa8b8" d="M39 4h-3V2c0-1.1-.9-2-2-2h-3c-1.1 0-2 .9-2 2v2H13V2c0-1.1-.9-2-2-2H8C6.9 0 6 .9 6 2v2H3C1.3 4 0 5.3 0 7v31c0 1.7 1.3 3 3 3h36c1.7 0 3-1.3 3-3V7c0-1.7-1.3-3-3-3zm1 34c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h5V2h3v4h20V2h3v4h5c.6 0 1 .4 1 1v31z"/><path fill="#9fa8b8" d="M15 20h4v2h-4zM23 20h4v2h-4zM31 20h4v2h-4zM7 25h4v2H7zM15 25h4v2h-4zM23 25h4v2h-4zM31 25h4v2h-4zM7 30h4v2H7zM15 30h4v2h-4zM23 30h4v2h-4z"/></svg>'};

/***/ }),

/***/ 656:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 94 75"><linearGradient id="a" x1="48%" y1="-10%" x2="48%" y2="78%"><stop offset="0" stop-color="#80c342"/><stop offset=".525" stop-color="#0f8851"/><stop offset="1" stop-color="#13444d"/></linearGradient><g fill="url(#a)"><path d="M15.4 71.1c-1.5 0-2.8-.6-3.9-1.6-1-1-1.6-2.4-1.6-3.9l-.2-52c0-3 2.5-5.5 5.5-5.5l66.2-.2c1.5 0 2.8.6 3.9 1.6 1 1 1.6 2.4 1.6 3.9l.2 52c0 3-2.5 5.5-5.5 5.5l-66.2.2zm66-60.2l-66.2.2c-1.4 0-2.5 1.1-2.5 2.5l.2 52c0 .7.3 1.3.7 1.8.5.5 1.1.7 1.8.7l66.2-.2c1.4 0 2.5-1.1 2.5-2.5l-.2-52c0-1.4-1.1-2.5-2.5-2.5z"/><circle cx="19.9" cy="61.1" r="1.5"/><circle cx="76.7" cy="60.9" r="1.5"/><circle cx="19.8" cy="18.1" r="1.5"/><circle cx="76.6" cy="17.9" r="1.5"/></g></svg>'};

/***/ }),

/***/ 657:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 73 73"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="33%" y1="-15%" x2="33%" y2="85%"><stop offset="0" stop-color="#80c342"/><stop offset=".525" stop-color="#0f8851"/><stop offset="1" stop-color="#13444d"/></linearGradient><g fill="url(#a)"><path d="M37.7 39.9c-.3 0-.6-.1-.8-.3l-9-6c-.7-.5-.9-1.4-.4-2.1.5-.7 1.4-.9 2.1-.4l6.7 4.4V21.2c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v17.2c0 .6-.3 1.1-.8 1.3-.3.1-.6.2-.8.2z"/><path d="M37.7 69.8c-17.3 0-31.4-14.1-31.4-31.4S20.4 7 37.7 7s31.4 14.1 31.4 31.4S55 69.8 37.7 69.8zm0-59.8C22 10 9.3 22.7 9.3 38.4S22 66.8 37.7 66.8s28.4-12.7 28.4-28.4S53.4 10 37.7 10z"/></g></svg>'};

/***/ }),

/***/ 658:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="357" height="357" viewBox="0 0 357 357"><path fill="#fff" d="M357 35.7L321.3 0 178.5 142.8 35.7 0 0 35.7l142.8 142.8L0 321.3 35.7 357l142.8-142.8L321.3 357l35.7-35.7-142.8-142.8z"/></svg>'};

/***/ }),

/***/ 659:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 96 65"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="47%" y1="-5%" x2="47%" y2="75%"><stop offset="0" stop-color="#80c342"/><stop offset=".525" stop-color="#0f8851"/><stop offset="1" stop-color="#13444d"/></linearGradient><g fill="url(#a)"><path d="M10.4 64.7c-3 0-5.5-2.5-5.5-5.5L4.8 10c0-3 2.5-5.5 5.5-5.5l74.2-.2c3 0 5.5 2.5 5.5 5.5l.2 49.2c0 3-2.5 5.5-5.5 5.5l-74.3.2c.1 0 .1 0 0 0zm-.1-57.2c-1.4 0-2.5 1.1-2.5 2.5L8 59.2c0 1.4 1.1 2.5 2.5 2.5l74.2-.2c1.4 0 2.5-1.1 2.5-2.5L87 9.8c0-1.4-1.1-2.5-2.5-2.5l-74.2.2zm0-1.5z"/><path d="M12.6 58.6c-.6 0-1-.4-1-1l-.1-46c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3l70-.2c.6 0 1 .4 1 1l.1 46c0 .3-.1.5-.3.7-.2.2-.4.3-.7.3l-70 .2zm.8-46l.1 44 68-.2-.1-44-68 .2z"/><path d="M68.8 21.1c-.3 0-.6-.2-.8-.4-.3-.5-.2-1.1.3-1.4l13.6-9c.5-.3 1.1-.2 1.4.3.3.5.2 1.1-.3 1.4l-13.6 9c-.2.1-.4.1-.6.1zM12.6 58.4c-.3 0-.6-.2-.8-.4-.3-.5-.2-1.1.3-1.4l13.1-8.7c.5-.3 1.1-.2 1.4.3.3.5.2 1.1-.3 1.4l-13.1 8.7c-.2 0-.4.1-.6.1z"/></g></svg>'};

/***/ }),

/***/ 660:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="378.94" height="378.94" viewBox="0 0 378.94 378.94"><path fill="#fff" d="M348.151 54.514c-19.883-19.884-46.315-30.826-74.435-30.826-28.124 0-54.559 10.942-74.449 30.826l-9.798 9.8-9.798-9.8c-19.884-19.884-46.325-30.826-74.443-30.826-28.117 0-54.56 10.942-74.442 30.826-41.049 41.053-41.049 107.848 0 148.885l147.09 147.091a16.036 16.036 0 0 0 8.527 4.461 16.29 16.29 0 0 0 3.161.303c4.161 0 8.329-1.587 11.498-4.764l147.09-147.091c41.051-41.037 41.051-107.832-.001-148.885zm-22.996 125.89L189.47 316.091 53.782 180.404c-28.368-28.364-28.368-74.514 0-102.893 13.741-13.739 32.017-21.296 51.446-21.296 19.431 0 37.702 7.557 51.438 21.296l21.305 21.312c6.107 6.098 16.897 6.098 23.003 0l21.297-21.312c13.737-13.739 32.009-21.296 51.446-21.296 19.431 0 37.701 7.557 51.438 21.296 28.371 28.379 28.371 74.528 0 102.893z"/></svg>'};

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 63 60"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="18%" y1="-5%" x2="18%" y2="69%"><stop offset="0" stop-color="#80c342"/><stop offset=".525" stop-color="#0f8851"/><stop offset="1" stop-color="#13444d"/></linearGradient><g fill="url(#a)"><path d="M14.2 35.7c-.8 0-1.5-.7-1.5-1.5 0-.6.1-13.7 8.7-23 .6-.6 1.5-.6 2.1-.1.6.6.6 1.5.1 2.1-7.8 8.4-7.9 20.9-7.9 21 0 .9-.6 1.5-1.5 1.5z"/><path d="M21.8 21.7c-.1 0-.3 0-.4-.1-.8-.2-1.2-1.1-1-1.9.1-.3 2.3-7.4 10-9.7 7.8-2.3 11.5 1.6 11.6 1.7.6.6.5 1.6-.1 2.1-.6.6-1.6.5-2.1-.1-.1-.1-2.6-2.6-8.5-.9-6.2 1.8-8 7.6-8 7.7-.3.8-.9 1.2-1.5 1.2zM41.9 48.5c-.8 0-1.5-.7-1.5-1.5 0-2.2 0-13.4 1.2-16.2.4-.9.8-1.4 1.2-1.9.6-.8 1.3-1.6 2.1-4.7 1-3.6-1.7-7-1.7-7-.5-.6-.4-1.6.2-2.1.6-.5 1.6-.4 2.1.2.1.2 3.6 4.6 2.3 9.7-1 3.7-1.9 4.9-2.7 5.8-.3.4-.6.7-.8 1.2-.7 1.6-1 9.7-.9 15 0 .8-.7 1.5-1.5 1.5zM17.7 48.8c-.8 0-1.5-.6-1.5-1.5-.2-9.7 1.1-18.7 1.2-19.1.1-.8.9-1.4 1.7-1.3.8.1 1.4.9 1.3 1.7 0 .1-1.4 9.2-1.2 18.6.1.9-.6 1.6-1.5 1.6.1 0 0 0 0 0zM25.8 48.5c-.7 0-1.3-.5-1.5-1.2-.4-1.8.3-11.5.5-13.4.1-.8.8-1.4 1.6-1.4.8.1 1.4.8 1.4 1.6-.4 5.5-.7 11.7-.5 12.6.2.8-.4 1.6-1.2 1.8h-.3z"/><path d="M37.8 48.9c-.9 0-1.5-.7-1.5-1.5 0-.4.3-9.1.6-13.5.4-4.9 2.5-6.9 2.7-7.1.6-.6 1.6-.5 2.1.1s.5 1.5-.1 2.1c-.1.1-1.5 1.5-1.8 5.1-.4 4.3-.6 13.3-.6 13.4.1.8-.6 1.4-1.4 1.4zM46 42.8c-.8 0-1.5-.6-1.5-1.4 0-.1-.2-3.2 0-5.5.2-2.6 1-4 1.1-4.2.4-.7 1.4-.9 2.1-.5.7.4.9 1.3.5 2.1 0 0-.6 1-.7 2.8-.2 2.2 0 5.1 0 5.1 0 .8-.6 1.5-1.5 1.6z"/><path d="M33.8 45.3c-.8 0-1.5-.6-1.5-1.4-.3-5.1.6-11.7 1.6-14.7.6-1.8 1.1-2.6 1.6-3.4.4-.7.9-1.3 1.4-2.7.3-.7.1-1.4-.3-1.9-.6-.7-1.7-1-3-.7-2 .5-4.2 6.1-5 9.7-.2.8-1 1.3-1.8 1.1-.8-.2-1.3-1-1.1-1.8.4-1.8 2.6-10.9 7.2-12 2.4-.6 4.6 0 6 1.6 1.2 1.4 1.5 3.3.9 5-.6 1.7-1.2 2.5-1.7 3.3-.5.7-.9 1.3-1.3 2.8-.9 2.6-1.7 8.9-1.4 13.6 0 .8-.7 1.5-1.6 1.5.1 0 0 0 0 0z"/><path d="M21.8 48.9s-.1 0 0 0c-.9 0-1.5-.7-1.5-1.6 0-.6.5-13.9 1.1-17.4.9-5.4 2.9-10.1 5.5-12.6 1.7-1.7 5.4-5.4 11.1-3.5 5.7 1.9 6.5 7.1 6.1 9.6-.1.8-.9 1.4-1.7 1.3-.8-.1-1.4-.9-1.3-1.7.1-.5.5-4.9-4.1-6.4-3.3-1.1-5.5.3-8 2.8-2.1 2.1-3.8 6.3-4.6 11-.6 3.3-1.1 16.9-1.1 17.1-.1.8-.7 1.4-1.5 1.4zM6.9 10.2c-.3 0-.5-.2-.5-.5V5.5c0-.3.3-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5H7.4v3.7c0 .3-.2.5-.5.5z"/><path d="M6.9 11.2c-.8 0-1.5-.7-1.5-1.5V5.5c0-.8.7-1.5 1.5-1.5h4c.8 0 1.5.7 1.5 1.5S11.8 7 10.9 7H8.4v2.7c0 .8-.6 1.5-1.5 1.5zM54 11.1c-.8 0-1.5-.7-1.5-1.5V7.1h-2.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5H54c.8 0 1.5.7 1.5 1.5v4c0 .8-.7 1.5-1.5 1.5zM11 54.1H6.8c-.8 0-1.5-.7-1.5-1.5v-4c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v2.5H11c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zM53.9 54.2h-4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h2.5v-2.7c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v4.2c0 .8-.6 1.5-1.5 1.5z"/></g></svg>'};

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="612" height="612" viewBox="0 0 612 612"><g fill="#fff"><path d="M604.267 194.727c4.257 0 7.733-3.644 7.733-7.733v-40.169c0-4.256-3.283-7.733-7.733-7.733H7.733c-4.256 0-7.733 3.644-7.733 7.733v40.169c0 4.256 3.283 7.733 7.733 7.733h596.534zM0 326.084c0 4.256 3.283 7.733 7.733 7.733h596.533c4.256 0 7.733-3.645 7.733-7.733v-40.169c0-4.284-3.283-7.733-7.733-7.733H7.733c-4.256 0-7.733 3.645-7.733 7.733v40.169zM0 465.175c0 4.256 3.283 7.733 7.733 7.733h596.533c4.256 0 7.733-3.645 7.733-7.733v-40.169c0-4.256-3.283-7.732-7.733-7.732H7.733c-4.256 0-7.733 3.644-7.733 7.732v40.169z"/></g></svg>'};

/***/ }),

/***/ 663:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 180 184"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="71%" y1="34%" x2="108%" y2="34%"><stop offset="0" stop-color="#6eec61"/><stop offset="1" stop-color="#78f4b6"/></linearGradient><g fill="url(#a)"><path d="M148 98.5c5.4-12.8 8.2-26.5 8.2-40.5h-12.5c0 12.4-2.4 24.4-7.2 35.7-4.6 10.9-11.2 20.7-19.6 29.1s-18.2 15-29.1 19.6c-11.3 4.8-23.3 7.2-35.7 7.2v12.5c14.1 0 27.7-2.8 40.6-8.2 12.4-5.2 23.5-12.8 33.1-22.3 9.4-9.5 16.9-20.6 22.2-33.1zM90.2 53.3c10.3 0 18.7-8.4 18.7-18.7 0-10.3-8.4-18.7-18.7-18.7-10.3 0-18.7 8.4-18.7 18.7 0 10.3 8.4 18.7 18.7 18.7zm0-24.8c3.4 0 6.1 2.8 6.1 6.1 0 3.4-2.8 6.1-6.1 6.1-3.4 0-6.1-2.8-6.1-6.1s2.7-6.1 6.1-6.1zM27.5 136.4c-10.3 0-18.7 8.4-18.7 18.7 0 10.3 8.4 18.7 18.7 18.7 10.3 0 18.7-8.4 18.7-18.7-.1-10.3-8.4-18.7-18.7-18.7zm0 24.8c-3.4 0-6.1-2.8-6.1-6.1 0-3.4 2.8-6.1 6.1-6.1 3.4 0 6.1 2.8 6.1 6.1s-2.7 6.1-6.1 6.1zM153 16c-10.3 0-18.7 8.4-18.7 18.7 0 10.3 8.4 18.7 18.7 18.7 10.3 0 18.7-8.4 18.7-18.7-.1-10.3-8.5-18.7-18.7-18.7zm0 24.8c-3.4 0-6.1-2.8-6.1-6.1 0-3.4 2.8-6.1 6.1-6.1s6.1 2.8 6.1 6.1-2.8 6.1-6.1 6.1z"/><path d="M103.1 72.9L91.8 84.2 80.5 72.9c-.4-.4-.9-.6-1.5-.6s-1.1.2-1.5.6l-4.8 4.8c-.8.8-.8 2.1 0 3L84 92l-11.3 11.3c-.8.8-.8 2.1 0 3l4.8 4.8c.4.4.9.6 1.5.6.5 0 1.1-.2 1.5-.6l11.3-11.3 11.3 11.3c.4.4.9.6 1.5.6s1.1-.2 1.5-.6l4.8-4.8c.8-.8.8-2.1 0-3L99.5 91.9l11.3-11.3c.4-.4.6-.9.6-1.5s-.2-1.1-.6-1.5l-4.8-4.8c-.8-.7-2.1-.7-2.9.1zM164.1 140.8l-4.8-4.8c-.8-.8-2.1-.8-3 0L145 147.3 133.8 136c-.8-.8-2.1-.8-3 0l-4.8 4.8c-.4.4-.6.9-.6 1.5s.2 1.1.6 1.5l11.3 11.3-11.3 11.2c-.4.4-.6.9-.6 1.5s.2 1.1.6 1.5l4.8 4.8c.4.4.9.6 1.5.6s1.1-.2 1.5-.6l11.3-11.3 11.3 11.3c.8.8 2.1.8 3 0l4.8-4.8c.4-.4.6-.9.6-1.5s-.2-1.1-.6-1.5L152.8 155l11.3-11.3c.8-.7.8-2.1 0-2.9zM54.1 111.3l4.8-4.8c.8-.8.8-2.1 0-3L47.6 92.3 58.9 81c.4-.4.6-.9.6-1.5s-.2-1.1-.6-1.5l-4.8-4.8c-.8-.8-2.1-.8-3 0L39.9 84.6 28.6 73.3c-.4-.4-.9-.6-1.5-.6s-1.1.2-1.5.6l-4.8 4.8c-.8.8-.8 2.1 0 3l11.3 11.3-11.3 11.3c-.8.8-.8 2.1 0 3l4.8 4.8c.8.8 2.1.8 3 0l11.3-11.3 11.3 11.3c.4.4.9.6 1.5.6.4-.2 1-.4 1.4-.8z"/></g></svg>'};

/***/ }),

/***/ 664:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 30 74"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="14%" y1="-7%" x2="14%" y2="101%"><stop offset="0" stop-color="#80c342"/><stop offset=".525" stop-color="#0f8851"/><stop offset="1" stop-color="#13444d"/></linearGradient><g fill="url(#a)"><path d="M14.7 70c-.3 0-.7-.1-.9-.3-.9-.8-8.8-7.3-8.8-12.4V16.7C5 11.3 9.4 7 14.7 7c5.3 0 9.7 4.3 9.7 9.7v40.7c0 5.1-7.8 11.6-8.7 12.3-.3.2-.7.3-1 .3zm0-60C11 10 8 13 8 16.7v40.7c0 2.5 3.8 6.6 6.7 9.2 2.9-2.6 6.7-6.7 6.7-9.2V16.7c0-3.7-3-6.7-6.7-6.7z"/><path d="M22.8 20H6.7c-.8 0-1.5-.7-1.5-1.5S5.9 17 6.7 17h16.1c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"/></g></svg>'};

/***/ }),

/***/ 665:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 77 85" fill="url(#a)"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="35%" y1="-5%" x2="35%" y2="99%"><stop offset="0" stop-color="#80c342"/><stop offset=".525" stop-color="#0f8851"/><stop offset="1" stop-color="#13444d"/></linearGradient><path d="M57.2 21.1c.7 0 1.3.6 1.3 1.3V65c0 .7-.6 1.3-1.3 1.3H14.6c-.7 0-1.3-.6-1.3-1.3V22.4c0-.7.6-1.3 1.3-1.3h42.6m0-3H14.6c-2.4 0-4.3 1.9-4.3 4.3V65c0 2.4 1.9 4.3 4.3 4.3h42.6c2.4 0 4.3-1.9 4.3-4.3V22.4c0-2.4-1.9-4.3-4.3-4.3z"/><path d="M20.9 20.9c-.8 0-1.5-.7-1.5-1.5V9.9c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.5c0 .9-.7 1.5-1.5 1.5zM30.9 20.9c-.8 0-1.5-.7-1.5-1.5V9.9c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.5c0 .9-.7 1.5-1.5 1.5zM40.9 20.9c-.8 0-1.5-.7-1.5-1.5V9.9c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.5c0 .9-.7 1.5-1.5 1.5zM50.9 20.9c-.8 0-1.5-.7-1.5-1.5V9.9c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.5c0 .9-.7 1.5-1.5 1.5zM20.9 78.9c-.8 0-1.5-.7-1.5-1.5v-9.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.5c0 .9-.7 1.5-1.5 1.5zM30.9 78.9c-.8 0-1.5-.7-1.5-1.5v-9.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.5c0 .9-.7 1.5-1.5 1.5zM40.9 78.9c-.8 0-1.5-.7-1.5-1.5v-9.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.5c0 .9-.7 1.5-1.5 1.5zM50.9 78.9c-.8 0-1.5-.7-1.5-1.5v-9.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.5c0 .9-.7 1.5-1.5 1.5zM69.6 30.2h-9.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h9.5c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5zM69.6 40.2h-9.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h9.5c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5zM69.6 50.2h-9.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h9.5c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5zM69.6 60.2h-9.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h9.5c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5zM11.6 30.2H2.1c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h9.5c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5zM11.6 40.2H2.1c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h9.5c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5zM11.6 50.2H2.1c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h9.5c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5zM11.6 60.2H2.1c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h9.5c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5z"/></svg>'};

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="792" height="792" viewBox="0 0 792 792"><path d="M580.802 369.604L211.198 0l-26.396 26.396L554.405 396 184.802 765.604 211.198 792l396-396z"/></svg>'};

/***/ }),

/***/ 667:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 90 118"><linearGradient id="a" x1="112.114" y1="70.563" x2="-33.886" y2="73.563"><stop offset="0" stop-color="#ffe187"/><stop offset="1" stop-color="#ffbe21"/></linearGradient><g fill="url(#a)"><path d="M71.6 44.4C64.2 37 54.4 33 44 33 22.5 33 5 50.5 5 72s17.5 39 39 39 39-17.5 39-39c0-10.5-4.1-20.3-11.4-27.6zM44 103c-17.1 0-31-13.9-31-31s13.9-31 31-31c8.3 0 16.1 3.2 21.9 9.1C71.8 55.9 75 63.7 75 72c0 17.1-13.9 31-31 31z"/><path d="M47.2 65.8L45.1 47c-.1-.5-.6-1-1.1-1-.5 0-1 .4-1.1 1l-2.2 18.8C38.5 67 37 69.3 37 72c0 3.9 3.1 7 7 7s7-3.1 7-7c0-2.7-1.5-5.1-3.8-6.2zM55 28V18c0-.6-.4-1-1-1H34c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h20c.6 0 1-.4 1-1zM76.3 43.9c.8.8 2.1.8 2.8 0l4.2-4.2c.8-.8.8-2.1 0-2.8l-4.2-4.2c-.8-.8-2.1-.8-2.8 0l-4.2 4.2c-.8.8-.8 2.1 0 2.8l4.2 4.2z"/></g></svg>'};

/***/ }),

/***/ 668:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 627.1 627.1"><path fill="none" d="M320.6 39.3c-2.4-.1-4.7-.1-7.1-.1s-4.7 0-7.1.1C160.6 43 43 160.6 39.3 306.4c-.1 2.4-.1 4.7-.1 7.1s0 4.7.1 7.1C43 466.5 160.6 584.1 306.4 587.8c2.4.1 4.7.1 7.1.1s4.7 0 7.1-.1c145.9-3.7 263.5-121.3 267.2-267.2.1-2.4.1-4.7.1-7.1s0-4.7-.1-7.1C584.1 160.6 466.5 43 320.6 39.3zm132.8 288.5c0 10.8-8.7 19.7-19.3 19.7H302.7c-10.6 0-19.3-8.9-19.3-19.7v-8.5c0-1.7.2-3.4.7-5V193.6c0-10.8 8.7-19.7 19.3-19.7h8.3c10.6 0 19.3 8.9 19.3 19.7v106.1h103.2c10.6 0 19.3 8.9 19.3 19.7v8.4z"/><path fill="#fff" d="M434.2 299.6H331v-106c0-10.8-8.7-19.7-19.3-19.7h-8.3c-10.6 0-19.3 8.9-19.3 19.7v120.7c-.4 1.6-.7 3.3-.7 5v8.5c0 10.8 8.7 19.7 19.3 19.7h131.5c10.6 0 19.3-8.9 19.3-19.7v-8.5c-.1-10.8-8.7-19.7-19.3-19.7z"/><path fill="#fff" d="M313.5 0C140.4 0 0 140.4 0 313.5 0 486.7 140.4 627 313.5 627 486.7 627 627 486.6 627 313.5 627.1 140.4 486.7 0 313.5 0zm274.4 313.5c0 2.4 0 4.7-.1 7.1-3.7 145.9-121.3 263.5-267.2 267.2-2.4.1-4.7.1-7.1.1s-4.7 0-7.1-.1C160.6 584.1 43 466.5 39.3 320.6c-.1-2.4-.1-4.7-.1-7.1s0-4.7.1-7.1C43 160.6 160.6 43 306.4 39.3c2.4-.1 4.7-.1 7.1-.1s4.7 0 7.1.1C466.5 43 584.1 160.6 587.8 306.4c0 2.4.1 4.8.1 7.1z"/></svg>'};

/***/ }),

/***/ 669:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 78 78"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="38%" y1="-2%" x2="38%" y2="88%"><stop offset="0" stop-color="#80c342"/><stop offset=".525" stop-color="#0f8851"/><stop offset="1" stop-color="#13444d"/></linearGradient><g fill="url(#a)"><path d="M65.4 72.4H11.8c-2.5 0-4.6-2.1-4.6-4.6v-53c0-2.5 2.1-4.6 4.6-4.6h53.6c2.5 0 4.6 2.1 4.6 4.6v53c0 2.6-2.1 4.6-4.6 4.6zM11.8 13.2c-.9 0-1.6.7-1.6 1.6v53c0 .9.7 1.6 1.6 1.6h53.6c.9 0 1.6-.7 1.6-1.6v-53c0-.9-.7-1.6-1.6-1.6H11.8z"/><path d="M53.3 37.9H23.8c-2.5 0-4.6-2.1-4.6-4.6V19.6c0-2.5 2.1-4.6 4.6-4.6h29.5c2.5 0 4.6 2.1 4.6 4.6v13.7c0 2.5-2 4.6-4.6 4.6zM23.8 18c-.9 0-1.6.7-1.6 1.6v13.7c0 .9.7 1.6 1.6 1.6h29.5c.9 0 1.6-.7 1.6-1.6V19.6c0-.9-.7-1.6-1.6-1.6H23.8z"/><path d="M40.2 37.9c-.4 0-.8-.1-1.1-.4L31 29.4c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l8.1 8.1c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4zM56.1 35.3c-.2 0-.4-.2-.5-.4-.1-.3-.1-.6-.2-.9-.1-.3.1-.5.4-.6.3-.1.5.1.6.4.1.3.2.7.2 1 .1.3-.1.5-.4.6 0-.1-.1-.1-.1-.1zM55.2 32.4c-.2 0-.4-.1-.5-.3-.2-.6-.5-1.2-.8-1.8-.1-.2 0-.5.2-.7.2-.1.5 0 .7.2.3.6.6 1.3.9 1.9.1.3 0 .5-.3.6-.1.1-.1.1-.2.1zm-33.3-.1h-.2c-.3-.1-.4-.4-.3-.6.3-.6.5-1.3.9-1.9.1-.2.4-.3.7-.2.2.1.3.4.2.7-.3.6-.6 1.2-.8 1.8-.1.1-.3.2-.5.2zm31.4-3.5c-.2 0-.3-.1-.4-.2-.4-.5-.8-1.1-1.2-1.6-.2-.2-.2-.5 0-.7.2-.2.5-.2.7.1.5.5.9 1.1 1.3 1.7.2.2.1.5-.1.7h-.3zm-29.4 0c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7.4-.6.8-1.1 1.3-1.7.2-.2.5-.2.7 0 .2.2.2.5 0 .7-.4.5-.8 1-1.2 1.6-.1.1-.3.2-.4.2zm26.8-3.1c-.1 0-.2 0-.3-.1-.5-.4-1-.9-1.5-1.3-.2-.2-.3-.5-.1-.7.2-.2.5-.3.7-.1.6.4 1.1.9 1.6 1.3.2.2.2.5 0 .7-.2.2-.3.2-.4.2zm-24.2 0c-.1 0-.3-.1-.4-.2-.2-.2-.2-.5 0-.7.5-.5 1.1-.9 1.6-1.3.2-.2.5-.1.7.1.2.2.1.5-.1.7l-1.5 1.2c0 .2-.1.2-.3.2zm20.9-2.4c-.1 0-.2 0-.2-.1l-1.8-.9c-.3-.1-.4-.4-.3-.7.1-.3.4-.4.7-.3.6.3 1.3.6 1.9.9.2.1.3.4.2.7-.2.4-.4.4-.5.4zm-17.6 0c-.2 0-.3-.1-.4-.3-.1-.2 0-.5.2-.7.6-.3 1.2-.7 1.9-.9.3-.1.5 0 .7.3.1.3 0 .5-.3.7-.6.3-1.2.5-1.8.9h-.3zm13.8-1.5h-.1c-.6-.2-1.3-.3-1.9-.4-.3 0-.5-.3-.4-.6 0-.3.3-.5.6-.4.7.1 1.4.3 2 .5.3.1.4.4.3.6-.1.1-.3.3-.5.3zm-10-.1c-.2 0-.4-.1-.5-.4-.1-.3.1-.5.3-.6.7-.2 1.4-.4 2-.5.3 0 .5.1.6.4 0 .3-.1.5-.4.6-.7.1-1.3.3-1.9.4 0 .1-.1.1-.1.1zm6-.6h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2.1c.3 0 .5.3.5.5-.1.3-.3.5-.6.5zM21.1 35.3H21c-.3-.1-.4-.3-.4-.6.1-.3.1-.7.2-1 .1-.3.3-.4.6-.4.3.1.4.3.4.6-.1.3-.2.6-.2.9-.1.3-.3.5-.5.5z"/></g></svg>'};

/***/ }),

/***/ 670:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 101 75"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="50%" y1="-12%" x2="50%" y2="98%"><stop offset="0" stop-color="#80c342"/><stop offset=".525" stop-color="#0f8851"/><stop offset="1" stop-color="#13444d"/></linearGradient><g fill="url(#a)"><path d="M13.4 69.2c-1.5 0-2.8-.6-3.9-1.6-1-1-1.6-2.4-1.6-3.9l-.1-50.2c0-3 2.5-5.5 5.5-5.5l74.2-.2c1.5 0 2.8.6 3.9 1.6 1 1 1.6 2.4 1.6 3.9l.2 50.2c0 3-2.5 5.5-5.5 5.5l-74.3.2c.1 0 .1 0 0 0zM13.3 11c-1.4 0-2.5 1.1-2.5 2.5l.2 50.2c0 .7.3 1.3.7 1.8.5.5 1.1.7 1.8.7l74.2-.2c1.4 0 2.5-1.1 2.5-2.5L90 13.2c0-.7-.3-1.3-.7-1.8-.5-.5-1.1-.7-1.8-.7l-74.2.3z"/><path d="M15.6 63.1c-.3 0-.5-.1-.7-.3-.2-.2-.3-.4-.3-.7l-.1-47c0-.6.4-1 1-1l70-.2c.3 0 .5.1.7.3.2.2.3.4.3.7l.1 47c0 .6-.4 1-1 1l-70 .2zm.8-47l.1 45 68-.2-.1-45-68 .2z"/><path d="M56.2 34.2c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l2-2c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-2 2c-.2.3-.5.3-.7.3zM52.3 32.1H52c-.5-.1-.9-.7-.7-1.2l.7-2.8c.1-.5.7-.8 1.2-.7.5.1.9.7.7 1.2l-.7 2.8c-.1.4-.5.7-.9.7zM47.8 32.1c-.4 0-.8-.3-1-.7l-.8-2.8c-.1-.5.2-1.1.7-1.2.5-.1 1.1.2 1.2.7l.8 2.8c.1.5-.2 1.1-.7 1.2h-.2zM44 34.5c-.3 0-.5-.1-.7-.3l-2-2c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2 2c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3zM41.9 38.4h-.3l-2.8-.7c-.5-.1-.9-.7-.7-1.2.1-.5.7-.8 1.2-.7l2.8.7c.5.1.9.7.7 1.2-.1.4-.5.7-.9.7zM39.2 43.5c-.4 0-.8-.3-1-.7-.1-.5.2-1.1.7-1.2l2.8-.8c.5-.1 1.1.2 1.2.7.1.5-.2 1.1-.7 1.2l-2.8.8h-.2zM42.2 48.8c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l2-2c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-2 2c-.2.2-.4.3-.7.3zM47.5 51.6h-.3c-.5-.1-.9-.7-.7-1.2l.7-2.8c.1-.5.7-.9 1.2-.7.5.1.9.7.7 1.2l-.7 2.8c-.1.4-.5.7-.9.7zM53.4 51.4c-.4 0-.8-.3-1-.7l-.8-2.8c-.1-.5.2-1.1.7-1.2.5-.1 1.1.2 1.2.7l.8 2.8c.1.5-.2 1.1-.7 1.2h-.2zM58.5 48.5c-.3 0-.5-.1-.7-.3l-2-2c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2 2c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3zM61.4 43.2h-.3l-2.8-.7c-.5-.1-.9-.7-.7-1.2.1-.5.7-.8 1.2-.7l2.8.7c.5.1.9.7.7 1.2 0 .4-.4.7-.9.7zM58.5 38c-.4 0-.8-.3-1-.7-.1-.5.2-1.1.7-1.2l2.8-.8c.5-.1 1.1.2 1.2.7.1.5-.2 1.1-.7 1.2l-2.8.8c0-.1-.1 0-.2 0z"/></g></svg>'};

/***/ }),

/***/ 671:
/***/ (function(module, exports) {

module.exports = {template: '<svg viewBox="0 0 105 105"><path fill-rule="evenodd" fill="#fff" d="M55.4 24.2v19.2c0 1-1 1.9-1.9 1.9h-3.4c-1 0-1.9-1-1.9-1.9V24.2H31.6v21.1c0 6.9.7 11.5 11.5 11.5h8.6c2.4 0 3.6-1.2 3.6-1.2v24.7h.2s6.3-2.7 11.5-7.9c3.6-3.6 6.7-8.1 6.7-13.9V24.2H55.4zM39.8 61.6c-6.2 0-8.2-5.5-8.2-5.3v2.2c0 5.8 2.7 10.2 6.7 13.9 5.8 5.5 12 7.9 12 7.9h.2V61.6H39.8z"/><path fill-rule="evenodd" fill="#fff" d="M22 13.6v46.1c0 21.5 28.8 31.7 28.8 31.7s1 .2 2 .2 2-.2 2-.2 28.8-10.2 28.8-31.7V13.6H22zm56.6 43.9c0 20.7-24.7 29-24.7 29s-.5.2-1.2.2-1.2-.2-1.2-.2-24.7-8.4-24.7-29V18.4h51.8v39.1z"/></svg>'};

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arrow_next.svg": 653,
	"./arrow_prev.svg": 654,
	"./calendar.svg": 655,
	"./case.svg": 656,
	"./clock.svg": 657,
	"./close.svg": 658,
	"./hd.svg": 659,
	"./heart.svg": 660,
	"./impress.svg": 661,
	"./menu.svg": 662,
	"./move.svg": 663,
	"./pen.svg": 664,
	"./processor.svg": 665,
	"./right-arrow-angle.svg": 666,
	"./timer.svg": 667,
	"./watch.svg": 668,
	"./weigher.svg": 669,
	"./windows.svg": 670
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 674;

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./main.js": 346
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 675;

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(325);
module.exports = __webpack_require__(324);


/***/ })

},[677]);


// WEBPACK FOOTER //
// static/js/app.js